<template>
  <div>
    <div class="title">加入我们</div>
    <!-- <div class="my_title">Hello,World</div> -->
    <!-- <h2 v-if="hireList.length > 0">招聘信息</h2> -->
    <div class="table" v-if="hireList.length > 0">
      <!-- <div class="item" v-for="item in hireList" :key="item.id" @click="routerTo(`/detail`, item)">
        <div>
          <i class="el-icon-d-arrow-right"></i> {{ item.title }}
        </div>
        <div>{{ item.createdTime | formatDate("YYYY-MM-DD") }}</div>
      </div> -->
      <el-collapse v-model="activeNames">
        <el-collapse-item  v-for="item in hireList" :key="item.id"  :name="item.id">
          <template slot="title">
            <div class="item">
            <div>
              {{ item.title }}
            </div>
            <div>{{ item.createdTime | formatDate("YYYY-MM-DD") }}</div>
          </div>
          </template>
          <div class="ql-editor" v-html="item.content"></div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- <hr v-if="hireList.length > 0" /> -->
    <div class="title" style="margin-top: 20px;">实验室地址</div>
    <div class="m-map" style="margin-top: 20px;">
      <baidu-map
        :center="location"
        :zoom="zoom"
      >
        <bm-marker
          :position="location"
          animation="BMAP_ANIMATION_BOUNCE"
        ></bm-marker>
        <bm-view
          style="width: 100%; height: 480px;"
        ></bm-view>
      </baidu-map>
    </div>
    <p v-if="teamDetail.address">地址: {{ teamDetail.address }}</p>
    <p v-if="teamDetail.busLine ">公交路线: {{ teamDetail.busLine }}</p>
    <hr />
    <h2 v-show="teamDetail.tel || teamDetail.email || teamDetail.otherContactInformation">联系方式</h2>
    <p v-if="teamDetail.tel">电话: {{ teamDetail.tel }}</p>
    <p v-if="teamDetail.email">邮箱: {{ teamDetail.email }}</p>
    <p v-if="teamDetail.otherContactInformation">其他: {{ teamDetail.otherContactInformation }}</p>
  </div>
</template>

<script>
import { listHire, getTeamDetail } from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  name: 'hello',
  data () {
    return {
      activeNames: [],
      teamDetail: {},
      hireList: [],
      location: {
        lng: 110.424128,
        lat: 25.320556
      }, // 指定地点的经纬度
      zoom: 18 // 地图缩放比例
    }
  },
  mounted () {},
  created () {
    this.listHire()
    this.getTeamDetail()
  },
  beforeDestroy () {},
  methods: {
    routerTo (path, row) {
      if (row) {
        row.typeName = '招聘信息'
        sessionStorage.detail = JSON.stringify(row)
      }
      this.$router.push({
        path
      })
    },
    listHire () {
      let data = {
        pageSize: 10
      }
      listHire(data).then((res) => {
        if (res.code === 200) {
          this.hireList = res.data
          if (this.hireList.length > 0) {
            let arr = []
            this.hireList.forEach(i => {
              arr.push(i.id)
            })
            this.activeNames = arr
          }
        }
      })
    },
    getTeamDetail () {
      getTeamDetail().then((res) => {
        if (res.code === 200) {
          this.teamDetail = res.data
        }
      })
    }
  }
}
</script>
<style scoped>
.title {
  letter-spacing: 1px;
  font-size: 28px;
  line-height:2em;
  color: #2f4f4f;
  border-bottom: 3px solid #2f4f4f;
  font-weight: bold;
}
.table {
  margin-top: 20px;
  border: 3px solid #2f4f4f;
  padding: 5px 20px;
  box-sizing: border-box;
}
.item {
  width: 1030px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 17px;
}
.item + .item {
  border-top: 1px solid #2f4f4f8c;
}
.item:hover {
  cursor: pointer;
  color: #d4af37;
}
.m-map-container {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
  background: #fff;
}
.m-map {
  margin: 0 auto;
}
.BMap_cpyCtrl .BMap_noprint.anchorBL {
  display: none!important;
}

.anchorBL {
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// src/view/joinUs.vue